import { render, staticRenderFns } from "./mobileFootTips.vue?vue&type=template&id=fed0e774&scoped=true"
import script from "./mobileFootTips.vue?vue&type=script&lang=js"
export * from "./mobileFootTips.vue?vue&type=script&lang=js"
import style0 from "./mobileFootTips.vue?vue&type=style&index=0&id=fed0e774&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed0e774",
  null
  
)

export default component.exports